module.exports = __webpack_public_path__ + "static/media/28_A.b4d89dc8.png";